import React from "react";

interface Props {
  onDragStart?: (start: [number, number], offset: [number, number]) => any;
  onDragEnd?: () => any;
  onClick?: () => any;
  className?: string;
}

export class Draggable extends React.Component<Props, {}> {
  dragTimeout?: number;
  element?: HTMLElement;

  constructor(props: Props) {
    super(props);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  handleMouseDown(ev: React.MouseEvent<HTMLElement>): void {
    const nativeEvent = ev.nativeEvent;
    document.addEventListener("mouseup", this.handleMouseUp, { capture: false });
    this.dragTimeout = window.setTimeout(() => {
      const { left, top } = this.element!.getBoundingClientRect();
      if (this.props.onDragStart) {
        const start: [number, number] = [nativeEvent.clientX, nativeEvent.clientY];
        const offset: [number, number] = [nativeEvent.clientX - left, nativeEvent.clientY - top];
        this.props.onDragStart(start, offset);
      }
      this.dragTimeout = undefined;
    }, 200);
  }

  captureClick = (ev: Event) => {
    ev.stopPropagation();
    window.removeEventListener("click", this.captureClick, true);
  };

  handleMouseUp(): void {
    if (this.dragTimeout) {
      clearTimeout(this.dragTimeout);
      if (this.props.onClick) {
        this.props.onClick();
        window.addEventListener("click", this.captureClick, true);
      }
      this.dragTimeout = undefined;
    } else {
      if (this.props.onDragEnd) {
        this.props.onDragEnd();
      }
    }
    document.removeEventListener("mouseup", this.handleMouseUp);
  }

  render() {
    return (
      <div
        className={this.props.className}
        onMouseDown={(ev) => this.handleMouseDown(ev)}
        ref={(el) => (this.element = el || undefined)}
      >
        {this.props.children}
      </div>
    );
  }
}
